<template>
  <div class="form-group" :class="{ 'has-danger' : errors.has(name) }">
    <div class="has-float-label">
      <input :style="styler" type="number" class="form-control" :id="name" :name="name" v-bind:value="value" :ref="name" v-validate="'numeric|' + validation" v-on:input="onInput" :placeholder="placeholder ? placeholder : label" :readonly="readonly">
      <label :for="name">{{label}}</label>
      <div class="form-control-feedback" v-if="errors.has(name)">{{ errors.first(name) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
    placeholder: String,
    readonly: String,
    name: String,
    styler: {
      default:''
    },
    validation:{
      default: ''
    }
  },
  methods: {
    onInput (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// FormTextNumber.vue?62f2a007